import { useNavigate } from "react-router-dom";
import PlusIcon from "../../../img/svg/plusIcon";
import XIcon from "../../../img/svg/xIcon";
import { useAuth } from "../../../context/authProvider";
import { useWatches } from "../../../context/watchProvider";
import { useState } from "react";
import LoadingBalls from "../../core/loadingBalls";

export default function Watch({ watch, isCart }: { watch: { [key: string]: any; id: string; }; isCart: boolean | undefined }) {

    const navigate = useNavigate();
    const { userId } = useAuth();
    const { addToCart, removeFromCart } = useWatches();
    const [loading, setLoading] = useState(false);

    const handleCart = async () => {
        if (!userId) {
            navigate("/gatekeeper");
            return null;
        }
        setLoading(true);
        if (isCart) {
            await removeFromCart(userId, watch.id);
            setLoading(false);
            return null;
        }
        await addToCart(userId, watch.id);
        setLoading(false);
    }

    return (
        <div
            onClick={() => navigate(watch.slug)}
            className="flex flex-col sm:flex-row p-4 gap-6 bg-white rounded-3xl border border-surface shadow-sm hover:shadow-xl transition-all duration-500 group cursor-pointer"
        >
            <div className="relative w-full sm:w-[180px] aspect-square rounded-2xl overflow-hidden bg-moninho border border-surface flex-shrink-0">
                <img
                    src={watch.cImgUrl}
                    className="h-full object-cover w-full transition-transform duration-700 group-hover:scale-110"
                    alt={watch.model}
                />
            </div>

            <div className="flex-1 flex flex-col justify-center gap-4 text-center sm:text-left">
                <div className="space-y-1">
                    <p className="text-[10px] sm:text-xs font-bold text-mono tracking-[0.2em] uppercase">
                        {watch.brand} | {watch.year}
                    </p>
                    <h3 className="text-xl sm:text-2xl font-black text-primary group-hover:text-secondary transition-colors leading-tight">
                        {watch.model.toUpperCase()}
                    </h3>
                    <p className="text-xl font-light text-secondary">
                        R${watch.price.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                    </p>
                </div>

                <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3 mt-2">
                    <button
                        onClick={(e) => { e.stopPropagation(); navigate(watch.slug); }}
                        className="px-6 py-2.5 bg-primary text-white text-[10px] font-bold tracking-widest rounded-full hover:bg-secondary transition-all"
                    >
                        DETALHES
                    </button>

                    {
                        loading ?
                            <div className="w-10 flex justify-center">
                                <LoadingBalls width={30} />
                            </div>
                            :
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleCart();
                                }}
                                className={`w-10 h-10 flex items-center justify-center rounded-full border-2 transition-all ${isCart
                                        ? "bg-moninho border-surface text-primary"
                                        : "bg-white border-primary/10 text-primary hover:border-secondary hover:text-secondary shadow-sm"
                                    }`}
                            >
                                {
                                    isCart ?
                                        <div title="Remover da minha lista">
                                            <XIcon fill="currentColor" width="16px" />
                                        </div>
                                        :
                                        <div title="Adicionar à minha lista">
                                            <PlusIcon fill="currentColor" width="16px" />
                                        </div>
                                }
                            </button>
                    }
                </div>
            </div>
        </div>
    )
}
